module.exports = __webpack_public_path__ + "static/img/product-swipe12.a40f45a3.png";